import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';
import { siteConfig } from '../data/mock';
import Logo from '../assets/Logo.svg'
const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Academics', path: '/academics' },
    { name: 'Activities', path: '/activities' },
    { name: 'Contact', path: '/contact' }
  ];

  const importantLinks = [
    { name: 'Maitreyi College', url: 'https://www.maitreyi.du.ac.in' },
    { name: 'University of Delhi', url: 'https://www.du.ac.in' },
    { name: 'NEP 2020', url: 'https://www.education.gov.in/nep' },
    { name: 'Ministry of Education', url: 'https://www.education.gov.in' }
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-25 h-25 bg-gradient-to-br from-primary to-orange-600 rounded-full flex items-center justify-center">
                {/* <span className="text-white font-bold text-lg">VAC</span> */}
                <img
                  src={Logo}
                  alt="VAC-IKS Logo"
                  className="w-20 h-20 rounded-full object-cover shadow-md group-hover:scale-105 transition-transform"
                />
              </div>
              <div>
                <div className="font-bold text-lg">{siteConfig.shortName}</div>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              {siteConfig.tagline}
            </p>
            <div className="devanagari text-primary/90 text-lg font-semibold">
              {siteConfig.motto}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-primary">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Important Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-primary">Important Links</h3>
            <ul className="space-y-2">
              {importantLinks.map((link) => (
                <li key={link.url}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-primary">Contact Us</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-primary" />
                <span>{siteConfig.address}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-primary" />
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="hover:text-primary transition-colors"
                >
                  {siteConfig.email}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-primary" />
                <a
                  href={`tel:${siteConfig.phone}`}
                  className="hover:text-primary transition-colors"
                >
                  {siteConfig.phone}
                </a>
                <span> | </span>
                <a
                  href={`tel:${siteConfig.phone2}`}
                  className="hover:text-primary transition-colors"
                >
                  {siteConfig.phone2}
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-3 mt-4">
              <a
                href={siteConfig.socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Youtube className="w-4 h-4" />
              </a>
              <a
                href={siteConfig.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href={siteConfig.socialMedia.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href={siteConfig.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={siteConfig.socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-4 text-sm text-gray-400">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2">

            {/* Left side text (single line on desktop) */}
            <p className="text-center md:text-left">
              © {new Date().getFullYear()} VAC-IKS, Maitreyi College, University of Delhi.
              All rights reserved.{" "}
              <span className="hidden md:inline">|</span>{" "}
              <span className="block md:inline text-xs md:text-sm mt-1 md:mt-0">
                Designed &amp; Developed by{" "}
                <a
                  href="https://www.linkedin.com/in/atulll/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-primary hover:text-white transition-colors font-medium"
                >
                  Atul Rajput
                </a>
              </span>
            </p>

            {/* Right side links */}
            <div className="flex space-x-4">
              <Link to="#" className="hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <span>|</span>
              <Link to="#" className="hover:text-primary transition-colors">
                Terms of Service
              </Link>
            </div>

          </div>
        </div>
      </div>
    </footer >
  );
};

export default Footer;
